module.exports = __webpack_public_path__ + "img/sos-type-green.83d61ed0.png";